import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Input, Modal, message, Button, notification } from "antd";
import SimpleReactValidator from "simple-react-validator";
import { createNewPage } from "../../utils/pages";
import "../SelectPages/SelectPages.css";
import "./NewPage.css";
import qs from "query-string";

const { Search } = Input;

const NewPage = () => {
  const location = useLocation();
  const history = useHistory();

  let validator = new SimpleReactValidator();

  const [modalOpen, setModalOpen] = useState(false);
  const [pageName, setPageName] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkParams = async () => {
      let params = qs.parse(location.search);
      if (params.status === "pageDeleted") {
        await openNotificationWithIcon("success", "pageDeleted");
        history.push("/new-page");
      }
    };
    checkParams();
    // eslint-disable-next-line
  }, []);

  const handleOk = (e) => {
    console.log(e);
  };

  const handleCancel = (e) => {
    console.log(e);
    setModalOpen(false);
  };

  const createPage = async () => {
    try {
      console.log("Create new page");
      // validator
      console.log(pageName);
      validator.message(
        "pageName",
        pageName,
        "alpha_num_dash|required|min:4|max:30"
      );
      if (validator.allValid()) {
        setLoading(true);
        let res = await createNewPage(pageName);
        console.log(res);
        if (res.message !== "ok") {
          message.error("😅 Opsss, ce nom de page est déjà pris.");
        } else {
          localStorage.setItem("pageToLoad", res.data);
          window.location.replace("/links?status=pageCreated");
          setModalOpen(false);
        }
        setLoading(false);
      } else {
        message.error(
          "Le champ doit faire entre 4 et 30 caractères contenant seulement des chiffres et lettres"
        );
      }
    } catch (e) {
      message.error("Erreur lors du changement de nom de page.");
    }
  };

  const openNotificationWithIcon = (type, event) => {
    if (event === "pageDeleted") {
      notification[type]({
        message: "Page supprimée avec succès.",
        description: "Votre page a bien été supprimée",
      });
    }
  };

  return (
    <div className="new-page-container">
      <div className="new-page-title">
        <span role="img" aria-label="emoji">
          🏄‍♂️
        </span>{" "}
        Créez votre première page Linksight pour commencer
      </div>
      <Button
        onClick={() => {
          setModalOpen(true);
        }}
        type="primary"
        style={{ fontSize: "18px", height: "50px", marginTop: "35px" }}
      >
        Créer une page
      </Button>
      <Modal
        footer={null}
        title=""
        visible={modalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="modal-container-new">
          <div className="add-new-page-title">Créer une nouvelle page</div>
          <Search
            prefix="https://linksight.me/"
            onChange={(e) => {
              setPageName(e.target.value);
            }}
            enterButton="Créer"
            size="large"
            loading={loading}
            onSearch={() => {
              createPage();
            }}
            // onClick={() => {

            // }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default NewPage;
